module.exports = __webpack_public_path__ + "static/media/washer.9e826880.gif";